// extracted by mini-css-extract-plugin
export default {"tickerInput":"TickerInput_tickerInput__vHqfZ","labelWrapper":"TickerInput_labelWrapper__5WpZk","select":"TickerInput_select__Xr0VV"};